import React, { useEffect, useState } from 'react';
import { Button, Form, InputGroup, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import validator from 'validator';
import { postRequest, postRequestWithoutAccessToken } from '../../helpers/apiHandler';
import CustomAlert from '../../components/CustomAlert';
import LeftSection from './LeftSection';
import config from '../../config/Constant';

const baseUrl = process.env.PUBLIC_URL;

const ResetPassword = () => {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState({ error: false, message: '' });
  const [confirmPasswordError, setConfirmPasswordError] = useState({ error: false, message: '' });
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const handleResetPasswordSubmit = evt => {
    evt.preventDefault();
    const form = evt.currentTarget;

    if (form.checkValidity() === false) {
      evt.stopPropagation();
    }

    if (validator.isEmpty(password)) {
      setPasswordError({
        error: true,
        message: 'Please enter your password',
      });
      return;
    }

    if (
      !validator.matches(
        password,
        /(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=]).*$/g
      )
    ) {
      setPasswordError({
        error: true,
        message:
          'Please choose a strong password that includes at least 1 lowercase and uppercase letter, a number, as well as a special character (!@#$%^&*)',
      });
      return;
    }

    if (!validator.isLength(password, { min: 8, max: undefined })) {
      setPasswordError({
        error: true,
        message: 'The password must be at least 8 characters long.',
      });
      return;
    }

    if (validator.isEmpty(confirmPassword)) {
      setConfirmPasswordError({
        error: true,
        message: 'Please enter your confirm password',
      });
      return;
    }

    if (
      !validator.matches(
        confirmPassword,
        /(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=]).*$/g
      )
    ) {
      setConfirmPasswordError({
        error: true,
        message:
          'Please choose a strong password that includes at least 1 lowercase and uppercase letter, a number, as well as a special character (!@#$%^&*)',
      });
      return;
    }

    if (!validator.isLength(confirmPassword, { min: 8, max: undefined })) {
      setConfirmPasswordError({
        error: true,
        message: 'The password must be at least 8 characters long.',
      });
      return;
    }

    if (password !== confirmPassword) {
      setConfirmPasswordError({
        error: true,
        message: "Password doesn't match.",
      });
      return;
    }

    setLoading(true);
    const data = {
      password: password,
      confirm_password: confirmPassword,
    };

    postRequest('/auth/reset-password', data, params.token, res => {
      if (!res.error) {
        setAlertState({
          message: res.message,
          show: true,
          variant: 'success',
        });
        setLoading(false);
        localStorage.removeItem('reset_password_data');
        setTimeout(() => {
          window.location.href = '/login';
        }, 3000);
      } else {
        setAlertState({
          message: res.message,
          show: true,
          variant: 'danger',
        });
        setLoading(false);
      }
    });
  };

  const validateToken = () => {
    const data = {
      token: params.token,
      type: 'password_reset',
    };

    postRequestWithoutAccessToken('/auth/validate-token', data, res => {
      if (!res.error) {
        setToken(token);
      } else {
        setAlertState({
          show: true,
          message: 'Token has expired.',
          variant: 'danger',
        });
        setTimeout(() => {
          window.location.href = `${baseUrl}/request-forgot-password`;
        }, 2000);
      }
    });
  };

  useEffect(() => {
    validateToken();
  }, []);

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <div className="Authenticate ResetPassword">
      <div className="container-auth-grid">
        <LeftSection />
        <div className="right-container">
          <div className="form-container-outter">
            <div className="form-container">
              <div className="form-top-section" style={{ marginBottom: 20 }}>
                <h3 style={{ marginBottom: 0 }}>Reset Password</h3>
              </div>
              <Form noValidate onSubmit={handleResetPasswordSubmit}>
                <CustomAlert
                  message={alertState.message}
                  show={alertState.show}
                  variant={alertState.variant}
                  closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
                />
                <Form.Group style={{ marginBottom: 20 }}>
                  <Form.Label>Enter New Password</Form.Label>
                  <InputGroup className="input-group-password" hasValidation>
                    <Form.Control
                      required
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Your Password"
                      name="password"
                      value={password}
                      onChange={evt => {
                        setPassword(evt.target.value);
                        setPasswordError({ error: false, message: '' });
                      }}
                      isInvalid={passwordError.error}
                    />
                    <InputGroup.Append>
                      <InputGroup.Text onClick={() => setShowPassword(!showPassword)}>
                        <img
                          src={require(`../../assets/AlertIcons/${showPassword ? 'icon-eye.svg' : 'icon-eye-close.svg'
                            }`)}
                          width={24}
                          height={24}
                          alt="..."
                        />
                      </InputGroup.Text>
                    </InputGroup.Append>
                    <Form.Control.Feedback type="invalid">
                      {passwordError.message}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
                <Form.Group style={{ marginBottom: 20 }}>
                  <Form.Label>Re-enter New Password</Form.Label>
                  <InputGroup className="input-group-password" hasValidation>
                    <Form.Control
                      required
                      type={showConfirmPassword ? 'text' : 'password'}
                      placeholder="Re-enter new password"
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={evt => {
                        setConfirmPassword(evt.target.value);
                        setConfirmPasswordError({ error: false, message: '' });
                      }}
                      isInvalid={confirmPasswordError.error}
                    />
                    <InputGroup.Append>
                      <InputGroup.Text onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                        <img
                          src={require(`../../assets/AlertIcons/${showConfirmPassword ? 'icon-eye.svg' : 'icon-eye-close.svg'
                            }`)}
                          width={24}
                          height={24}
                          alt="..."
                        />
                      </InputGroup.Text>
                    </InputGroup.Append>
                    <Form.Control.Feedback type="invalid">
                      {confirmPasswordError.message}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
                <Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={loading}
                    style={{ minWidth: '160px' }}
                  >
                    {loading && <Spinner animation="border" size="sm" className="mr-2" />}
                    Reset Password
                  </Button>
                </Form.Group>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
